import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { FleetService } from '../../../services/fleet/fleet.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBar, MAT_DIALOG_DATA, MAT_CHIPS_DEFAULT_OPTIONS, MatDialog } from '@angular/material';
import { TransporterService } from '../../../services/transporter/transporter.service';
import { Router } from '@angular/router';
import { StoreUserDetails } from 'src/app/auth/storeuserdetails';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-editfleet',
  templateUrl: './editfleet.component.html',
  styleUrls: ['./editfleet.component.scss']
})
export class EditfleetComponent implements OnInit {
  fleetForm: FormGroup;
  vehicleMake: string;
  vehicleModel: string;
  vehicleYear: string;
  vehicleType: string;
  vehicleLicenseNumber: string;
  vehicleIdNumber: string;
  vehicleRegistrationDate: string;
  vehicleOdometerReading: string;
  carryingType: string;
  bodyHeight: Number;
  bodyLength: Number;
  bodyWidth: Number;
  bodyVolumetricCapacity: Number;
  bodyWeightCapacity: Number;
  description: string;
  transporter: string;
  ownership: string;
  transporterName: any;
  alreadySelectedtransporterName: string;
  alltransporters = [];
  constructor(
    private matDialog: MatDialog,
    public fleetService: FleetService,
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public transporterservice: TransporterService,
    private router: Router,
    private userDetails: StoreUserDetails,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) {

    this.fleetForm = formBuilder.group({
      'vehicleMake': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'vehicleModel': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'vehicleYear': [null, [
        Validators.pattern('^[0-9]*$')
      ]],
      'vehicleType': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'vehicleLicenseNumber': [null, [
        Validators.pattern("^[a-zA-Z0-9]+$")
      ]],
      'vehicleIdNumber': [null, Validators.pattern("^[a-zA-Z0-9_ ]+$")],
      'vehicleRegistrationDate': [null],
      'vehicleOdometerReading': [null, [
        Validators.pattern('^[0-9]*$')
      ]],
      'carryingType': [null],
      'bodyHeight': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'bodyLength': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'bodyWidth': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'bodyVolumetricCapacity': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'bodyWeightCapacity': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'addDocument': [null],
      'description': [null],
      'transporter': [null,
        Validators.required
      ],
      'ownership': [null],
      'bIsActive': [null],
      'branchName': [null],
      'creationDateTime': [null],
      'fState': [null],
      'fleetId': [null],
      'preferedDriver': [null],
      'updatedByusername': [null]
    })

  }
  openSnackBar(message) {
    let extraClasses;

    this.snackBar.open(message, "X", {
      duration: 100000,
    });
  }

  ngOnInit() {
    this.fleetForm.controls["vehicleLicenseNumber"].disable();
    this.getTransporter();
    console.log(this.data); // here is the data from from all fleet to edit screen here
    //we will call single data get call
    //let fleetData = {licenseNumber: this.data}

    console.log(this.data);

    //call fleet service here
    //change base_url inside fleet serivces
    this.fleetService.getFleetByVehicleLicenseNumber(this.data).subscribe(res => {
      console.log(res);
      if (res.transporter)
        this.alreadySelectedtransporterName = res.transporter.transporterName;
      this.fleetForm.patchValue({
        bodyHeight: res.bodyHeight,
        bodyLength: res.bodyLength,
        bodyVolumetricCapacity: res.bodyVolumetricCapacity,
        bodyWeightCapacity: res.bodyWeightCapacity,
        bodyWidth: res.bodyWidth,
        carryingType: res.carryingType,
        description: res.description,
        vehicleIdNumber: res.vehicleIdNumber,
        vehicleLicenseNumber: res.vehicleLicenseNumber,
        vehicleMake: res.vehicleMake,
        vehicleModel: res.vehicleModel,
        vehicleOdometerReading: res.vehicleOdometerReading,
        vehicleRegistrationDate: res.vehicleRegistrationDate,
        vehicleType: res.vehicleType,
        vehicleYear: res.vehicleYear,
        transporter: res.transporter,
        ownership: 'self',
        addDocument: '',
        bIsActive: res.bIsActive,
        branchName: res.branchName,
        creationDateTime: res.creationDateTime,
        fState: res.fState,
        fleetId: res.fleetId,
        preferedDriver: res.preferedDriver,
        updatedByusername: this.userDetails.getUser()
      })
    }, Error => {
      console.log(Error);
    })
  }

  getTransporter() {
    this.transporterservice.getAllTransporters().subscribe(transporterDetails => {
      this.alltransporters = transporterDetails;
      console.log("alltransporters", this.alltransporters);
    })
  }

  selectRegDate(event) {
    let date = new Date(event.value);
    this.fleetForm.value.vehicleRegistrationDate = this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  editFleet() {
    //call fleet service here
    //change base_url inside fleet serivces
    this.fleetForm.value.vehicleLicenseNumber = this.data.licenseNumber;
    console.log("fleetform value", this.fleetForm.value)
    this.fleetService.updateFleet(this.fleetForm.value).subscribe(res => {
      console.log(res);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(["/managefleet"]));
      this.matDialog.closeAll();
      this.openSnackBar("Fleet: " + this.fleetForm.value.vehicleLicenseNumber + " updated successfully");
    }, Error => {
      console.log(Error);
    })
  }
}
